import React from "react";
import PredictionPage from "../../components/PredictionPage";

function GBPUSD() {
  return (
    <PredictionPage
      title="GBPUSD"
      content="This is the GBPUSD AI Trading Predictions page."
      canonical="/forex-majors/gbpusd-ai-trading-predictions"
      categoryKey="nav.forexMajors"
      categoryPath="/forex-majors"
      symbol="GBPUSD"
    />
  );
}

export default GBPUSD;
